export const REFRESH_BY_HEADER = 'pleaseRefreshByHeader'
export const REQUEST_SUCCESS = '0'
